import { useState ,useEffect } from 'react';
import { Link } from 'react-router-dom';
import Nav from './Nav';

const HeaderTwo= ({id}) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isScrolled, setIsScrolled] = useState(false);

    const openMenu = () => {
        setIsMenuOpen(true);
      };
    const closeMenu = () => {
        setIsMenuOpen(false);
      };

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
      
    return (
        <>
            <header id={id} className="header-style-2">
                <div className={`header-navbar navbar-sticky ${windowWidth <= 991 ? 'mobile-menu' : ''}`} >
                    <div className="container">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="site-logo">
                                <Link to="#" className="logo-wrapper">
                                    <img className='niec-logo logo-white-2' src={`${process.env.PUBLIC_URL}/assets/images/logo-white.png`} alt="niec-nav-logo-white"/>
                                    <img className='niec-logo logo-color-2' src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="niec-nav-logo-color"/>
                                </Link>
                                <Link to="#" className='logo-wrapper'>
                                    <img className='super-student-logo logo-color-2' src={`${process.env.PUBLIC_URL}/assets/images/logo2.png`} alt="super-student-nav-logo-color"/>
                                    <img className='super-student-logo logo-white-2' src={`${process.env.PUBLIC_URL}/assets/images/logo-ss-white.png`} alt="super-student-nav-logo-white"/>
                                </Link>
                            </div>

                            <div className="offcanvas-icon d-block d-lg-none">
                                <a onClick={openMenu} className="nav-toggler"><i className="fal fa-bars"></i></a> 
                            </div>
                            <nav className={ `site-navbar ms-auto ${ isMenuOpen ? 'menu-on': ''}` } >
                                <Nav onLinkClick={closeMenu} />
                                {isMenuOpen && (
                                    <a onClick={closeMenu}  className="nav-close"><i className="fal fa-times"></i></a>
                                )}
                            </nav>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default HeaderTwo;